import InlineEditInput from './inlineEditInput';

export default InlineEditInput;
